export default "__VITE_ASSET__Dsinw0o$__"